import {
  FaChartBar,
  FaClock,
  FaHashtag,
  FaMicrophone,
  FaTags,
  FaUser,
  FaUserTie,
  FaVideo,
} from "react-icons/fa";
import { RadialBarChart } from "./dashboard";
import { useState } from "react";
import CountdownTimer from "../interview/timerComponent";
import { WarningCard } from "../reusble_components/reportScreen";
import Loader from "../reusble_components/loader";

export default function Mistakes() {
  const [showGrammaticalMistakes, setShowGrammaticalMistakes] = useState(true);
  const [showVocabularyMistakes, setShowVocabularyMistakes] = useState(false);
  const [showTimer, setShowTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isResultGenerated, setIsResultGenerated] = useState(true);

  const GrammaticalMistakes = [
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
  ];

  const VocabularyMistakes = [
    {
      whatYouSaid:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
      CorrectForm:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    },
    {
      whatYouSaid:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
      CorrectForm:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    },
    {
      whatYouSaid:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
      CorrectForm:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    },
    {
      whatYouSaid:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
      CorrectForm:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Enim dolores voluptatem perferendis nam excepturi nemo, voluptatibus deserunt inventore veritatis assumenda!",
    },
  ];

  const hitResultAPI = () => {
    setLoading(true);
    setShowTimer(true);
    //   const body = {
    //     interviewId: interviewId,
    // };
  };

  return (
    <div className="w-full mx-auto p-4 md:p-8 lg:p-12 gil-reg bg-slate-100 relative">
      <Loader loader={loading} />
      <div className="justify-between mb-6 md:flex ">
        <h1 className="text-2xl gil-bold">Spoken English Report</h1>
      </div>
      <div className="md:hidden lg:hidden block">
        {!isResultGenerated && <WarningCard onRegenerate={hitResultAPI} />}
      </div>

      <div className="flex md:flex-row lg:flex-row flex-col">
        <div className=" bg-white rounded-xl shadow-lg w-full md:w-3/4 lg:w-3/4">
          <div className=" p-3 flex flex-col lg:flex-row md:flex-row items-center justify-around">
            <RadialBarChart score={23} label={"Grammar"} />
            <RadialBarChart score={89} label={"Story Telling"} />
            <RadialBarChart score={89} label={"Vocabulary"} />
            <RadialBarChart score={89} label={"Fluency"} />
          </div>
          <p className="text-center text-2xl mb-2">Mistakes heading</p>
          <div className="flex justify-center ">
            <button
              onClick={() => {
                setShowGrammaticalMistakes(!showGrammaticalMistakes);
                setShowVocabularyMistakes(!showVocabularyMistakes);
              }}
              className={`mx-3 rounded-xl px-2 md:px-6 lg:px-6 py-2 ${
                showGrammaticalMistakes
                  ? "border border-primary text-primary"
                  : null
              } `}
            >
              Grammatical mistakes
            </button>
            <button
              className={`mx-3 rounded-xl px-2 lg:px-6 md:px-6 py-2 ${
                showVocabularyMistakes
                  ? "border border-primary text-primary"
                  : null
              } `}
              onClick={() => {
                setShowVocabularyMistakes(!showVocabularyMistakes);
                setShowGrammaticalMistakes(!showGrammaticalMistakes);
              }}
            >
              Vocabulary mistakes
            </button>
          </div>
          <div className="p-4">
            {showGrammaticalMistakes &&
              GrammaticalMistakes.map((item, index) => {
                return (
                  <div key={index} className=" p-4 my-4 ">
                    <p>{item}</p>
                  </div>
                );
              })}
          </div>
          <div className="p-4">
            {showVocabularyMistakes &&
              VocabularyMistakes.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="flex flex-col md:flex-row lg:flex-row w-[95%] mx-auto justify-around p-4 my-4 "
                  >
                    <div className="flex flex-col w-[100%] my-2 md:w-[45%] lg:w-[45%]  mx-auto items-center ">
                      <p className="mb-1">what you have said</p>
                      <p className="text-justify text-[#7F7F7F] ">
                        {item?.whatYouSaid}
                      </p>
                    </div>
                    <div className="flex flex-col w-[100%] md:w-[48%] lg:w-[48%] mx-auto items-center">
                      <p className="mb-1">Correct Form</p>
                      <p className="text-justify pl-0 md:border-opacity-70 lg:border-opacity-70 md:pl-8 lg:pl-8 md:border-l lg:border-l border-l-[#DFDFDF] text-[#7F7F7F]">
                        {item?.CorrectForm}
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="block md:hidden lg:hidden w-full">
          {InterviewBasicData()}
        </div>
        <div className="w-1/4 pl-4 hidden md:block lg:block">
          {showTimer && (
            <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
              <h2 className="text-xl gil-bold mb-4">Please wait</h2>
              <CountdownTimer />

              <p className="mt-2">
                Please wait untill time ends.{" "}
                <span className="text-yellow">Then Refresh this page</span>{" "}
              </p>
            </div>
          )}
          {!isResultGenerated && <WarningCard onRegenerate={hitResultAPI} />}
          <div className="md:block hidden lg:block"> {skillsAssesment()}</div>
          <div className="md:block hidden lg:block">
            {" "}
            {InterviewBasicData()}
          </div>
        </div>
      </div>
    </div>
  );

  function InterviewBasicData() {
    return (
      <div className="bg-white shadow-lg rounded-lg p-4 my-8 md:my-0 lg:my-0">
        <h2 className="text-xl gil-bold mb-4">Interview Details</h2>
        <div className="flex items-center mb-4">
          <FaUser className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewee:</span>{" "}
            {/* {interviewData?.interviewee?.name} */}
            Kalyan
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaClock className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Duration:</span>
            {/* {getRecordedTime()} */} --
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaUserTie className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Interviewer:</span>{" "}
            {/* {interviewData?.interviewerName ?? "Lucy"} */}
            Lucy
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaTags className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Topic:</span>{" "}
            {/* {interviewData?.technology ?? "-"} */} -
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaHashtag className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">ID:</span>
            {/* {interviewData?._id ?? "-"} */} -
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaMicrophone className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Microphone:</span>
            {"Allowed"}
            {/* {interviewDetails.interviewPermissionMic
          ? "Allowed"
          : "Not Allowed"} */}
          </p>
        </div>
        <div className="flex items-center mb-4">
          <FaVideo className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Video:</span>
            {"Allowed"}
            {/* {interviewDetails.interviewPermissionVideo
          ? "Allowed"
          : "Not Allowed"} */}
          </p>
        </div>
        <div className="flex items-center">
          <FaChartBar className="mr-2 text-gray-500" />
          <p>
            <span className="gil-bold">Level:</span>
            {"High"}
            {/* {interviewData?.levelOfInterview} */}
          </p>
        </div>
      </div>
    );
  }

  function skillsAssesment() {
    return (
      <div className="bg-white shadow-lg rounded-lg p-4 mb-8">
        <h2 className="text-xl gil-bold mb-4">Skills Assessment</h2>
        <div>
          <h3 className="gil-bold">Grammar</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${(23 / 10) * 10}%`,
              }}
            ></div>
          </div>
          <p>{23 / 10}/10</p>
        </div>
        <div>
          <h3 className="gil-bold">story telling</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${(89 / 10) * 10}%`,
              }}
            ></div>
          </div>
          <p>{89 / 10}/10</p>
        </div>
        <div>
          <h3 className="gil-bold">Vocabulary</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${(89 / 10) * 10}%`,
              }}
            ></div>
          </div>
          <p>{89 / 10}/10</p>
        </div>
        <div>
          <h3 className="gil-bold">Fluency</h3>
          <div className="relative w-full bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-2 bg-primary"
              style={{
                width: `${(89 / 10) * 10}%`,
              }}
            ></div>
          </div>
          <p>{89 / 10}/10</p>
        </div>
      </div>
    );
  }
}
